import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from './contexts/AuthContext'
import { ProtectedRoute } from './components/auth/ProtectedRoute'
import { AuthCallback } from './components/auth/AuthCallback'
import { Layout } from './components/layout/Layout'
import { Login } from './views/Login'
import { Dashboard } from './views/Dashboard'
import { Suggestions } from './views/Suggestions'
import { Users } from './views/Users'
import { MemberProfile } from './views/MemberProfile'
import Freetext from './views/Freetext'
import { CanonicalPieces } from './views/CanonicalPieces'
import { CanonicalComposers } from './views/CanonicalComposers'
import { Questions } from './views/Questions'
import { QuestionDetail } from './views/QuestionDetail'
import { Surveys } from './views/Surveys'
import { SurveyDetail } from './views/SurveyDetail'
import { Toaster } from '@brent/core-ui/ui'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/auth/callback" element={<AuthCallback />} />

            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/suggestions" element={<Suggestions />} />
              <Route path="/freetext" element={<Freetext />} />
              <Route path="/canonical-pieces" element={<CanonicalPieces />} />
              <Route path="/canonical-composers" element={<CanonicalComposers />} />
              <Route path="/questions" element={<Questions />} />
              <Route path="/questions/:id" element={<QuestionDetail />} />
              <Route path="/surveys" element={<Surveys />} />
              <Route path="/surveys/:id" element={<SurveyDetail />} />
              <Route
                path="/users"
                element={
                  <ProtectedRoute requiredGroup="administrator">
                    <Users />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/users/:username"
                element={
                  <ProtectedRoute requiredGroup="administrator">
                    <MemberProfile />
                  </ProtectedRoute>
                }
              />
            </Route>

            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  )
}

export default App
